<template>
  <hr-module no-header blue logo>
    <hr-module-header
      class="hr-module-header-title"
      :title="t('block-module:title')"
    >
      <p class="hr-module-header">{{ t('block-module:description') }}</p>
    </hr-module-header>

    <h-r-module-section>
      <div class="block_module_image">
        <img
          src="../../static/images/error@2x.png"
          data-test-id="hr-page--error"
        />
      </div>
    </h-r-module-section>
  </hr-module>
</template>

<script>
import HrModule from '@/components/hr-module';
import HrModuleHeader from '@/components/hr-module-header.vue';
import HRModuleSection from '@/components/HRModuleSection';
import t from '@/lib/i18next';

export default {
  name: 'block-module',
  components: { HrModule, HrModuleHeader, HRModuleSection },
  setup() {
    return {
      t,
    };
  },
};
</script>

<style lang="scss">
.block_module_image img {
  margin: 18px 0px;
  width: 500px;
}

.hr-module-header-title {
  font-size: 32px;
}

.hr-module-header {
  font-size: 14px;
  color: #6c6a72;
}

.hr-module-header p {
  font-size: 14px;
  color: var(--co-text-secondary);

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
}

@media screen and (max-width: 787px) {
  .block_module_image img {
    max-height: initial;
    width: 100%;
  }
}
</style>
